module.exports = __webpack_public_path__ + "img/ខ្លា.ba432b28.png";